export default "/images/63b56c30f61d7d6baadf79cb2766c321.avif";